import React, { FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getError } from '../../model/selectors';
import { clearError } from '../../model/actions';
import { getErrorDetailsText } from '@shared/error';
import { ErrorModal } from '@shared/ui/ErrorModal';
import { useTranslation } from 'react-i18next';

interface Props {
	confirmBtn?: ReactElement<Element> | string;
	cancelBtn?: ReactElement<Element> | string;
	onConfirm?: () => void;
	onCancel?: () => void;
	onClose?: () => void;
}

const ErrorManager: FC<Props> = ({ confirmBtn, cancelBtn, onConfirm, onCancel, onClose }) => {
	const { t } = useTranslation('ErrorManager');

	const dispatch = useDispatch();
	const error = useSelector(getError);

	const detailsText = getErrorDetailsText(error?.details);

	const handleClearError = () => {
		dispatch(clearError());
	};

	const handleCloseError = () => {
		handleClearError();
		onClose?.();
	};

	const handleConfirm = () => {
		handleClearError();
		onConfirm?.();
	};

	const handleCancel = () => {
		handleClearError();
		onCancel?.();
	};

	if (!error) {
		return null;
	}

	return (
		<ErrorModal
			isOpen={!!error}
			header={t('ErrorManagerModal.Header')}
			title={error.title || t('ErrorManagerModal.Title')}
			message={error.message || t('ErrorManagerModal.Message')}
			details={error.details}
			detailsText={detailsText || t('ErrorManagerModal.DetailsText')}
			detailsTitle={t('ErrorManagerModal.DetailsTitle')}
			detailsDescription={t('ErrorManagerModal.DetailsDescription')}
			confirmBtn={confirmBtn || t('ErrorManagerModal.ConfirmButton')}
			cancelBtn={cancelBtn}
			onClose={handleCloseError}
			onConfirm={handleConfirm}
			onCancel={onCancel ? handleCancel : undefined}
		/>
	);
};

export default ErrorManager;
